import React, {isValidElement} from 'react';
import cn from 'classnames';

import createCtx from 'coreUtils/createCtx';

import {useTabsCtx} from '../../Tabs';

import {ITabPaneProps} from './ITabPane';

import styles from './TabPane.module.scss';

export const [useTabCtx, TabProvider] = createCtx<{tabId: string}>();

const TabPane = ({classNames, children, sys: {id}}: ITabPaneProps) => {
	const {activeTabId} = useTabsCtx();

	return (
		<TabProvider value={{tabId: id}}>
			<div
				id={`tabpane-${id}`}
				className={cn(styles['tabs__tab'], classNames, {[styles['tabs__tab--active']]:
						((activeTabId === '' && id.startsWith('1')) || id === activeTabId)})}
			>
				{isValidElement(children) && children}
			</div>
		</TabProvider>
	);
};

export default TabPane;
